import { media_actions } from "../actions/actionTypes";

const initialState = {
  loading: false,
  uploadedMedia: null,
  updatedMedia: null,
  error: null,
};

export const mediaReducer = (state = initialState, action) => {
  switch (action.type) {
    case media_actions.UPLOAD_MEDIA_REQUEST:
    case media_actions.UPDATE_MEDIA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case media_actions.UPLOAD_MEDIA_SUCCESS:
      return {
        ...state,
        loading: false,
        uploadedMedia: action.payload,
      };

    case media_actions.UPDATE_MEDIA_SUCCESS:
      return {
        ...state,
        loading: false,
        updatedMedia: action.payload,
      };

    case media_actions.UPLOAD_MEDIA_FAILURE:
    case media_actions.UPDATE_MEDIA_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    default:
      return state;
  }
};
